import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HandymanIcon from '@mui/icons-material/Handyman';
import InsightsIcon from '@mui/icons-material/Insights';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { ReactElement } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

type Tab = {
  label: string;
  /** /locations/:locationId/ 以下のサブパス */
  sub: string;
  icon: ReactElement;
  /** アクティブ判定。`exact` が true ならサブパス完全一致、それ以外は startsWith。 */
  match: { sub: string; exact?: boolean }[];
};

const TABS: Tab[] = [
  {
    label: 'ユニット',
    sub: 'units',
    icon: <Inventory2Icon />,
    match: [{ sub: 'units' }],
  },
  {
    label: 'データポイント',
    sub: 'datapoints',
    icon: <InsightsIcon />,
    match: [{ sub: 'datapoints' }],
  },
  {
    label: 'ツール',
    sub: 'toolbox',
    icon: <HandymanIcon />,
    match: [{ sub: 'toolbox' }, { sub: 'setup' }, { sub: 'qr' }, { sub: 'installation' }, { sub: 'carry-out' }],
  },
  {
    label: '設定',
    sub: 'settings',
    icon: <AccountCircleIcon />,
    match: [{ sub: 'settings' }],
  },
];

/** 固定 BottomNavigation。ツール起動中は MobileShell 側で非表示。 */
export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { locationId } = useParams<{ locationId: string }>();

  if (!locationId) return null;

  // /locations/:locationId/ 以下を切り出す
  const prefix = `/locations/${locationId}`;
  const sub = location.pathname.startsWith(prefix)
    ? location.pathname.slice(prefix.length).replace(/^\//, '')
    : '';

  const activeTab =
    TABS.find((t) =>
      t.match.some((m) =>
        m.exact ? sub === m.sub : sub === m.sub || sub.startsWith(`${m.sub}/`),
      ),
    )?.sub ?? false;

  return (
    <Paper
      square
      elevation={3}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <BottomNavigation
        showLabels
        value={activeTab}
        onChange={(_, newValue) => {
          if (typeof newValue === 'string') {
            navigate(`${prefix}/${newValue}`);
          }
        }}
        sx={{
          // ラベルが折り返さないように、必要に応じて縮めて一行に収める
          '& .MuiBottomNavigationAction-label': {
            whiteSpace: 'nowrap',
            fontSize: '0.65rem',
            '&.Mui-selected': { fontSize: '0.68rem' },
          },
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            px: 0.5,
          },
        }}
      >
        {TABS.map((tab) => (
          <BottomNavigationAction
            key={tab.sub}
            label={tab.label}
            value={tab.sub}
            icon={tab.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};
